<template>
  <div class="d-flex items-items-center justify-content-center text-center mb-3" id="app">
    <div v-bind:style="dndStyle" class="dnd mx-4 d-flex justify-content-center align-items-center flex-column w-100"
      @dragover="dragover" @dragleave="dragleave" @drop="drop">
      <div class="d-flex justify-content-center align-items-center flex-column">
        <input type="file" name="fields[assetsFieldHandle][]" id="assetsFieldHandle" class="d-none" @change="onChange"
          ref="file" multiple :accept="acceptFile == 'zip' ? '.zip' : 'audio/*, audio/x-mp3, audio/x-m4a, audio/x-wav'" />
        <img src="../assets/upload_ico.png" alt="" />

        <label for="assetsFieldHandle" class="">
          Drop files in here <br />
          or<br />
          <span class="btn">browse</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { fileNameHasSpecialCharacters } from "@/utils/string-utils";
export default {
  props: ["type", "acceptFile"],
  data() {
    return {
      dndStyle: "background-color: #f0f0f0; border: 4px dashed #737375;",
    }; // Store our uploaded files}
  },
  computed: {
    elementList() {
      return this.$store.state.trackData.currentElement !== "" &&
        this.$store.state.trackData.currentMix !== ""
        ? 0
        : 1;
    },
    elementListClass() {
      return this.$store.state.trackData.currentElement !== "" &&
        this.$store.state.trackData.currentMix !== ""
        ? ""
        : "disable";
    },
  },
  methods: {
    addTrackFile(file) {
      // create current object with add details

      let objData = {
        element: this.$store.state.trackData.currentElement,
        mixType: this.$store.state.trackData.currentMix,
        file: file,
        uploadStatus: 0,
      };
      //   function to dispatch data
      this.addCurrentTrackData(objData);
    },
    onChange(e) {
      for (let i = 0; i <= e.target.files.length - 1; i++) {
        console.log(e.target.files[i].name.split("."));
        if (
          e.target.files[i].name.split(".").length > 2 ||
          fileNameHasSpecialCharacters(e.target.files[i].name.split(".")[0])
        ) {
          this.$swal.fire({
            icon: "error",
            title: "Unsupported filename...",
            text: "Filename must not contain special characters",
          });
        } else {
          this.addTrackFile(e.target.files[i]);
        }
      }
    },
    remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
      this.dndStyle =
        "background-color: #cfdafd88; border: 4px dashed #b8c7fd;";
      // Add some visual fluff to show the user can drop its files
    },
    dragleave() {
      this.dndStyle = "background-color: #f0f0f0; border: 4px dashed #737375;";
    },
    drop(event) {
      event.preventDefault();
      // let file = event.dataTransfer.files;
      for (let i = 0; i <= event.dataTransfer.files.length - 1; i++) {
        this.addTrackFile(event.dataTransfer.files[i]);
      } // Trigger the onChange event manually
    },
    addCurrentTrackData(data) {
      if (this.$props.type == "ref") {
        this.$store.dispatch("trackData/currentRef", data);
      } else if (this.$props.type == "track") {
        this.$store.dispatch("trackData/currentData", data);
      } else {
        // else
      }
    },
  },
};
</script>

<style scoped>
.dnd label {
  color: black !important;
}

.dnd {
  padding: 50px 0px !important;
  background-color: #f0f0f0;
  border-radius: 8px;
  border: 4px dashed #737375;
  position: relative;
  z-index: 0;
}

.btn {
  border-radius: 30px;
  padding: 6px 16px;
  background-color: #26ffd4;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(194, 194, 194, 0.705);
  /*dim the background*/
  pointer-events: none !important;
  border-radius: 8px;
}

.disable {
  pointer-events: none !important;
  border: 4px dashed rgba(109, 109, 109, 0.356);
}
</style>
